import { render, staticRenderFns } from "./ActivityPage.vue?vue&type=template&id=63947580"
import script from "./ActivityPage.vue?vue&type=script&lang=ts"
export * from "./ActivityPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports